export default "__VITE_PUBLIC_ASSET__adac4769__"